<template>
  <form class="columns is-multiline" @submit.prevent="sendForm">
    <b-field class="column is-12" label="Título de la reunión *" label-position="horizontal">
      <b-input v-model="form.titulo" required placeholder="Ej. Seguimiento mensual"></b-input>
    </b-field>

    <b-field class="column is-6" label="Fecha *" label-position="horizontal">
      <b-input v-model="form.fecha" type="date" required></b-input>
    </b-field>

    <b-field class="column is-6" label="Lugar *" label-position="horizontal">
      <b-input v-model="form.lugar" required placeholder="Sala de juntas, auditorio, etc."></b-input>
    </b-field>

    <b-field class="column is-12" label="Descripción" label-position="horizontal">
      <b-input v-model="form.descripcion" type="textarea" placeholder="Contexto o agenda de la reunión"></b-input>
    </b-field>

    <div class="column is-12">
      <ImageInput
        label="Portada"
        infoText="JPG o PNG, máximo 2MB."
        name="imagenes_id"
        id="imagenes_id"
        imageType="imagenes_id"
        :initial-url="form.portada"
        @file-selected="handleFileSelected"
      />
    </div>

    <b-field class="column is-12" label="Estatus" label-position="horizontal">
      <b-switch v-model="form.activo" :true-value="true" :false-value="false">Activado</b-switch>
    </b-field>

    <div class="column is-12">
      <div class="buttons is-right">
        <b-button type="is-text" @click="closeForm">Cancelar</b-button>
        <b-button type="is-primary" native-type="submit" icon-left="content-save">Guardar reunión</b-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
import ImageInput from '@/components/common/imageInput.vue';

export default {
  components: {
    ImageInput,
  },
  props: {
    datavalues: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {},
      initialFormState: {
        id: null,
        titulo: '',
        fecha: '',
        lugar: '',
        descripcion: '',
        portada: '',
        activo: true,
        imagenFile: null,
      },
    };
  },
  watch: {
    datavalues: {
      immediate: true,
      handler(newValue) {
        this.loadFormData(newValue);
      },
    },
  },
  methods: {
    ...mapActions({
      saveMeeting: 'meetings/saveMeeting',
    }),
    loadFormData(data) {
      if (data && Object.keys(data).length) {
        this.form = { ...this.initialFormState, ...data };
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const response = await this.saveMeeting(this.form);

      Swal.fire({
        icon: response.status ? 'info' : 'error',
        title: response.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });

      if (response.status) {
        this.$store.commit('meetings/SET_DATA', { key: 'reloadList', data: true });
        this.closeForm();
      }
    },
    handleFileSelected(fileData) {
      this.form.imagenFile = fileData?.file || null;
    },
    closeForm() {
      this.$emit('close-form');
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
</style>
